<template>
  <v-container class='pt-7 pb-11'>
    <h1 class='text-h4 mb-5'>{{ 'requestsBookingsPerformance'|localize }}</h1>
    <div class='white elevation-2 rounded mb-8'>
      <v-row class="my-0" align="center">
        <v-col class="py-0">
          <v-tabs v-model="tab" background-color="transparent" class="grey--text text--lighten-1">
            <v-tab :ripple="false" href="#all_companies" class="text-none">
              {{ 'allCompaniesRequests'|localize }}
            </v-tab>
            <v-tab :ripple="false" href="#by_transport_company" class="text-none">
              {{ 'requestsByTransportCompany'|localize }}
            </v-tab>
            <v-tab :ripple="false" href="#not_booked" class="text-none">
              {{ 'notBookedRequests'|localize }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-divider class="mb-0"/>
      <AdminPerformanceReports v-if='tab === "all_companies"' :companies='companies' :companiesLoading='companiesLoading' :tab='tab'/>
      <AdminRequestsBookingsReports v-if='tab === "by_transport_company"' :companies='companies' :companiesLoading='companiesLoading' :tab='tab'/>
      <AdminNotBookedReports v-if='tab === "not_booked"' :companies='companies' :companiesLoading='companiesLoading' :tab='tab'/>
    </div>
  </v-container>
</template>

<script>
  import AdminPerformanceReports from '@/components/AdminPerformanceReports';
  import AdminRequestsBookingsReports from '@/components/AdminRequestsBookingsReports.vue';
  import AdminNotBookedReports from '@/components/AdminNotBookedReports.vue';
  import api from '@/api/api';

  export default {
    name: 'AdminReports',
    components: {AdminNotBookedReports, AdminRequestsBookingsReports, AdminPerformanceReports},

    data() {
      return {
        tab: 'all_companies',
        companiesLoading: false,
        companies: []
      };
    },

    mounted() {
      this.getCompanies();
    },

    methods: {
      async getCompanies() {
        try {
          this.companiesLoading = true;
          let companiesData = await api.getAdminCompanies({per_page: 1000, page: 1, sort: { field: "title", desc: false }});
          this.companies = companiesData.data?.data || [];
        } catch (e) {} finally {
          this.companiesLoading = false;
        }
      },
    }
  };
</script>
